import React from 'react';
import { green, grey } from '@mui/material/colors';
import { DoneAll, PhoneDisabled } from '@mui/icons-material';
import { Box, Typography } from '@mui/material';

interface Props {
  isAnswered: boolean;
}

export const CallStatus = ({ isAnswered }: Props) => {
  return (
    <Box
      sx={{
        gap: '0.25rem',
        display: 'flex',
        padding: '0 0.25rem',
        borderRadius: '0.5rem',
        backgroundColor: isAnswered ? green[200] : grey[200],
        border: `1px solid ${isAnswered ? green[300] : grey[300]}`,
      }}
    >
      {isAnswered ? <DoneAll color={isAnswered ? 'success' : 'disabled'} /> : <PhoneDisabled color="disabled" />}
      <Typography color={isAnswered ? 'success' : 'textSecondary'}>{isAnswered ? 'Answered' : 'No Answer'}</Typography>
    </Box>
  );
};
